<template>
  <div id="app">
    <Nav />
    <Main />
    <b-container class="home-content mt-5 mb-5">
      <b-row class="justify-content-md-center">
        <b-col md="10" class="text-center mt-3">
          <p>
            Sign language is a language that consists of body movements, especially of hand and arms, some facial expressions, and some special symbols for alphabets and numbers. Normal people are not able to decode those sign gestures. Technology can help in decoding the alphabets and translating them to words or sentences. There should be a system that acts as a mediator between mute and normal people. So the proposed system aims at converting those sign gestures into text/speech which is understood by normal people. So this Automated Sign To text/speech conversion system helps in decoding those symbols without the need of an expert person who understands the sign language.
          </p>
        </b-col>
      </b-row>
    </b-container>
    <About msg="Software Architecture"/>
    <Motivation msg="How Technology can help" />
    <Ibm msg="Chatbot" />
    <Chatbot msg="About Us"/>
  </div>
</template>

<script>
import Chatbot from './components/Chatbot.vue'
import Nav from './components/Nav.vue'
import Main from './components/Main.vue'
import About from './components/About.vue'
import Motivation from './components/Motivation.vue'
import Ibm from './components/Ibm.vue'

export default {
  name: 'App',
  components: {
    Chatbot,
    Nav,
    Main,
    About,
    Motivation,
    Ibm
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
#app img {
  max-width: 100%;
}
#app h1, #app h2 {
  font-weight: 600;
  color: #e83e8c;
  text-transform: uppercase;
}
.students {
  text-transform: uppercase;
}
#app .bg-info {
  background: #fff !important;
  border-bottom: 1px solid #dbd8d8;
  position: sticky;
  top: 0;
  z-index: 99;
}
.navbar-dark .navbar-toggler {
  background: #e83e8c;
}
#app .bg-info a {
  color: #000 !important;
}
#app .bg-info a.navbar-brand {
  color: #e83e8c !important;
  font-weight: 600;
}
.home-content {
  font-weight: 600;
}
p {
  font-weight: 600;
}
</style>
